import {
  getObject,
} from "@surya-digital/leo-ts-types";
import { HexCode, HexCodeDTO } from "../types/hexCode";

export interface PrimaryColorTokensDTO {
  primary100Code: HexCodeDTO;
  primary200Code: HexCodeDTO;
  primary300Code: HexCodeDTO;
  primary400Code: HexCodeDTO;
  primary500Code: HexCodeDTO;
}

export class PrimaryColorTokens {
  readonly isPrimaryColorTokensPrimaryColorTokens: boolean = true;

  readonly primary100Code: HexCode;
  readonly primary200Code: HexCode;
  readonly primary300Code: HexCode;
  readonly primary400Code: HexCode;
  readonly primary500Code: HexCode;


  constructor(
  primary100Code: HexCode, 
  primary200Code: HexCode, 
  primary300Code: HexCode, 
  primary400Code: HexCode, 
  primary500Code: HexCode
  ) {
    this.primary100Code = primary100Code;
    this.primary200Code = primary200Code;
    this.primary300Code = primary300Code;
    this.primary400Code = primary400Code;
    this.primary500Code = primary500Code;
  }

  static fromDTO(dto: PrimaryColorTokensDTO): PrimaryColorTokens {
    const primary100Code = HexCode.fromDTO(getObject(dto, "primary100Code", InvalidPrimaryColorTokensPrimary100CodeError));
    const primary200Code = HexCode.fromDTO(getObject(dto, "primary200Code", InvalidPrimaryColorTokensPrimary200CodeError));
    const primary300Code = HexCode.fromDTO(getObject(dto, "primary300Code", InvalidPrimaryColorTokensPrimary300CodeError));
    const primary400Code = HexCode.fromDTO(getObject(dto, "primary400Code", InvalidPrimaryColorTokensPrimary400CodeError));
    const primary500Code = HexCode.fromDTO(getObject(dto, "primary500Code", InvalidPrimaryColorTokensPrimary500CodeError));
    return new PrimaryColorTokens(
      primary100Code,
      primary200Code,
      primary300Code,
      primary400Code,
      primary500Code
    );
  }

  toDTO(): PrimaryColorTokensDTO {
    const dto: PrimaryColorTokensDTO = {
        primary100Code: this.primary100Code.toDTO(),
        primary200Code: this.primary200Code.toDTO(),
        primary300Code: this.primary300Code.toDTO(),
        primary400Code: this.primary400Code.toDTO(),
        primary500Code: this.primary500Code.toDTO()
    };
    return dto;
  }
  }

PrimaryColorTokens.prototype.toString = function toString(): string {
  return `PrimaryColorTokens(primary100Code='${this.primary100Code}',primary200Code='${this.primary200Code}',primary300Code='${this.primary300Code}',primary400Code='${this.primary400Code}',primary500Code='${this.primary500Code}')`;
};

export class InvalidPrimaryColorTokensError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidPrimaryColorTokensError";
  }
}
export class InvalidPrimaryColorTokensPrimary100CodeError extends InvalidPrimaryColorTokensError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidPrimaryColorTokensPrimary100CodeError";
  }
}

export class InvalidPrimaryColorTokensPrimary200CodeError extends InvalidPrimaryColorTokensError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidPrimaryColorTokensPrimary200CodeError";
  }
}

export class InvalidPrimaryColorTokensPrimary300CodeError extends InvalidPrimaryColorTokensError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidPrimaryColorTokensPrimary300CodeError";
  }
}

export class InvalidPrimaryColorTokensPrimary400CodeError extends InvalidPrimaryColorTokensError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidPrimaryColorTokensPrimary400CodeError";
  }
}

export class InvalidPrimaryColorTokensPrimary500CodeError extends InvalidPrimaryColorTokensError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidPrimaryColorTokensPrimary500CodeError";
  }
}
